import React, { useState, memo } from 'react';
import classnames from 'classnames';
import Table from 'rc-table';

import { deepCopy } from '../utils/tools';

import { BaseWidgetProps } from '../utils/type';
import { ColumnProps } from './interface';

import { dealDataHeight, dealColumns, getValueFromPath } from './utls';

export interface TableProps extends BaseWidgetProps {
  columns?: ColumnProps[];
  data?: any[];
  footer?: any;
  bordered?: boolean;
  pagination?: any;
  className?: string;
  num?: number;
  openText?: string;
  closeText?: string;
  columnManager: any;
  store: any;
  getRowKey: any;
  valueKey?: string;
  emptyText?: string,
  theme?: 'orange' | 'default';
}

function UTable(props: TableProps) {
  const {
    prefixCls = 'crm-table',
    className,
    columns,
    data = [],
    num = 10,
    openText = '展开',
    closeText = '收起',
    theme = 'default',
    valueKey = '',
    _crengine,
    emptyText = '暂无数据',
    ...others
  } = props;

  const [open, setOpen] = useState(false);

  const cls = classnames({
    [`${prefixCls}`]: true,
    [`${theme}`]: true,
  }, className);

  let tempColumns;

  let tempData;

  // 配置数据从cdata中获取
  if (typeof valueKey === 'string' && valueKey !== '') {
    const { cdata } = _crengine || {};
    tempColumns = columns;
    tempData = getValueFromPath(deepCopy(cdata), valueKey) || [];
  } else {
    tempData = deepCopy(data);
    tempColumns = dealColumns(columns, data);
  }

  const showBtn = num < tempData.length;

  if (!open) {
    tempData = tempData.splice(0, num);
    tempData = dealDataHeight(tempData, num);
  }

  const optionsCls = classnames({
    [`${prefixCls}-option`]: true,
    [`${prefixCls}-close`]: open,
  });

  return (
    <div
      className={cls}
    >
      <Table
        {...others}
        emptyText={emptyText}
        columns={tempColumns}
        data={tempData}
      />
      {showBtn && (
        <div
          className={optionsCls}
          onClick={() => {
            setOpen(!open);
          }}
        >
          {open ? closeText : openText}
        </div>
      )}
    </div>
  );
}

export default memo(UTable);
